
export function convertGrowthDataToChartFormat(data, growth10 = false) {
    var graphData;

    if (growth10) {

        if (data.TimeSeries.Security[0].GrowthSeries == null) {
            return;
        }

        graphData = data.TimeSeries.Security[0].GrowthSeries[0].HistoryDetail;
    }

    else {
        graphData = data.TimeSeries.Security[0].HistoryDetail;
    }

    return graphData;
}

export function fetchGrowthGraphData(id, startDate, endDate, growth10 = false) {
    var baseUrl = `${process.env.GATSBY_WP_API_URL}/qte-morningstar/v1/timeseries`;
    var url = `${baseUrl}?id=${id}&startDate=${startDate}&endDate=${endDate}`;
    return fetch(url)
        .then(response => response.json())
        .then(data => convertGrowthDataToChartFormat(data, growth10))
        .catch(error => error);
}

export function renderGrowthChart (chartData, elemId, percentage=false, shortLabels = false, fundName = 'Prior', firstValue = 0) {

const standardLineOptions = {
    fill: true,
    borderWidth: 0.5,
    pointRadius: 0,
    lineTension: 0.2,
    backgroundColor: (context) => {
        const chart = context.chart;
        const { ctx, chartArea } = chart;

        if (!chartArea) return; // Ensure chartArea is available

        // Create gradient
        const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
        gradient.addColorStop(0, '#a2b8eb00'); // Start color
        gradient.addColorStop(1, 'white'); // End color (white)

        return gradient;
    }
};



    const verticalHoverLine = {
    id: 'vertical-hover-line',
    beforeDraw(chart, args, options) {
        const { ctx, chartArea } = chart;
        const tooltip = chart.tooltip;
        const activeElements =
            tooltip && typeof tooltip.getActiveElements === 'function'
                ? tooltip.getActiveElements()
                : tooltip && tooltip._active
                    ? tooltip._active
                    : [];

        // Ensure tooltip is active and has at least one active point
        if (!Array.isArray(activeElements) || activeElements.length === 0) {
            return;
        }

        // Get the first active point from tooltip
        const activePoint = activeElements[0] && activeElements[0].element;
        if (!activePoint || typeof activePoint.x !== 'number') {
            return;
        }

        const x = activePoint.x;

        // Draw vertical line
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, chartArea.top);
        ctx.lineTo(x, chartArea.bottom);
        ctx.lineWidth = 1;
        ctx.strokeStyle = 'rgba(128, 128, 128, 0.2)'; // Semi-transparent gray
        ctx.transition = 0.1;
        ctx.stroke();
        ctx.restore();
    }
};

    
    const ctx = document.getElementById(elemId) as HTMLCanvasElement;

    if (!ctx) {
        return;
    }

    // Clear the container
    ctx.innerHTML = '';
    
    // Create canvas element for the chart
    var canvas = document.createElement('canvas');
    canvas.id = 'growthGraph';
    document.getElementById(elemId).appendChild(canvas);

    // Loop through the chartData.datasets and set the options
    chartData.datasets.forEach((dataset: any) => {
        dataset = Object.assign(dataset, standardLineOptions);
    });

    var maxTickXLimit = window.innerWidth < 768 ? 5 : 10;
    var maxTickYLimit = window.innerWidth < 768 ? 5 : 10;

    if (window.innerWidth < 450) {
        maxTickXLimit = 4;
        maxTickYLimit = 5;
    }

    new Chart(canvas, {
        type: 'line',
        data: chartData,
        options: {
            maintainAspectRatio: false,
            interaction: {
                mode: 'index',
                intersect: false,
            },
            scales: {
                x: {
                    grid: {
                        display: false,
                    },
                    // Make sure labels are aligned and the empty labels are ignored
                    ticks: {
                        autoSkip: true,  // We keep all data points, but we'll handle label visibility below
                        callback: function(value: any, index: number) {
                            var currentDate = new Date(chartData.labels[index]);

                            if (shortLabels) {
                                return currentDate.toLocaleString('sv-SE', { day: '2-digit', month: 'short' });
                            } else {
                                return currentDate.toLocaleString('sv-SE', { month: 'short', year: 'numeric' });
                            }

                        },
                        maxTicksLimit: maxTickXLimit,
                        maxRotation: 0,  // Rotate labels if needed
                        minRotation: 0,
                    },
                },
                y: {
                    grid: {
                        display: false,
                    },
                    ticks: {
                        autoSkip: false,
                        maxTicksLimit: maxTickYLimit,
                        callback: function(value: any, index: number) {
                            if (percentage)
                                return value + ' %';
                            else
                                return value;
                        }
                    },
                }
            },
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                    },
                },
                tooltip: {
                    intersect: false,
                    enabled: false,
                    external: function(context) {
                        // Tooltip Element
                        let tooltipEl = document.getElementById('chartjs-tooltip');

                        // Append style to the document.body
                        if (!document.getElementById('chartjs-tooltip-style')) {
                            let style = document.createElement('style');
                            style.id = 'chartjs-tooltip-style';
                            var styleHtml = `
                                #chartjs-tooltip {
                                    border-radius: 20px;
                                    border: 1px solid #eee;
                                    padding: 20px;
                                    font-size: 20px;
                                    text-align: center;
                                    background-color: white;
                                    transition: 0.1s;
                                }

                                #chartjs-tooltip .title {
                                    font-size: 20px;
                                    color: #001E63;
                                    font-weight: bold;
                                }

                                #chartjs-tooltip .date {
                                    font-size: 14px;
                                    color: gray;
                                    font-weight: light;
                                }

                                #chartjs-tooltip .value {
                                    margin-top: 2px;
                                    font-weight: 600;
                                    font-size: 16px;
                                }

                                #chartjs-tooltip .positive {
                                    color: #20c220;
                                }

                                #chartjs-tooltip .negative {
                                    color: #ee5050;
                                }
                            `;
                            style.innerHTML = styleHtml;
                            document.head.appendChild(style);
                        }

                        // Create element on first render
                        if (!tooltipEl) {
                            tooltipEl = document.createElement('div');
                            tooltipEl.id = 'chartjs-tooltip';
                            tooltipEl.innerHTML = '<table></table>';
                            document.body.appendChild(tooltipEl);
                        }

                        // Hide if no tooltip
                        const tooltipModel = context.tooltip;
                        if (tooltipModel.opacity === 0) {
                            tooltipEl.style.opacity = 0;
                            return;
                        }

                        // Set caret Position
                        tooltipEl.classList.remove('above', 'below', 'no-transform');
                        if (tooltipModel.yAlign) {
                            tooltipEl.classList.add(tooltipModel.yAlign);
                        } else {
                            tooltipEl.classList.add('no-transform');
                        }

                        // Set Text
                        if (tooltipModel.body) {
                            var date = new Date(tooltipModel.dataPoints[0].label);
                            var percentageValue = Math.round(tooltipModel.dataPoints[0].parsed.y * 100) / 100;

                            // firstValue
                            var currentValue = tooltipModel.dataPoints[0].parsed.y;

                            if (!percentage) {
                                var percentageDifference = (currentValue - firstValue) / firstValue * 100;
                                percentageValue = Math.round(percentageDifference * 100) / 100;
                            }
                            else {
                                percentageValue = Math.round(percentageValue * 100) / 100;
                            }

                            // If percentageValue is positive, add a plus sign
                            var percentageClass = 'negative';
                            if (percentage && currentValue >= 0 || !percentage && percentageValue >= 0) {
                                if (!percentage)
                                    percentageValue = '+' + percentageValue;

                                percentageClass = 'positive';
                            }

                            percentageValue += ' %';

                            var currentValueSwedish = !percentage ? currentValue.toLocaleString('sv-SE', { style: 'currency', currency: 'SEK' }) : '';

                            let innerHtml = '';

                            innerHtml = '<thead>';
                                innerHtml += '<tr><th class="date">' + date.toLocaleDateString('sv-SE', { weekday: 'long', month: 'short', year: 'numeric' }) + '</th></tr>';
                            innerHtml += '</thead>';

                            innerHtml += '<tbody>';
                                const tooltipTitle = '<div class="title">' + fundName + '</div>';
                                const tooltipValue = '<div class="value">' + currentValueSwedish + '<span class="'+ percentageClass +'"> ' + percentageValue + '</span></div>';
                                innerHtml += '<tr><td>' + tooltipTitle + tooltipValue + '</td></tr>';
                            innerHtml += '</tbody>';

                            let tableRoot = tooltipEl.querySelector('table');
                            if (tableRoot) {
                                tableRoot.innerHTML = innerHtml;
                            }
                        }

                        const position = context.chart.canvas.getBoundingClientRect();
                        const bodyFont = Chart.helpers.toFont(tooltipModel.options.bodyFont);

                        // Display, position, and set styles for font
                        tooltipEl.style.opacity = 1;
                        tooltipEl.style.position = 'absolute';
                        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                        tooltipEl.style.font = bodyFont.string;
                        tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
                        tooltipEl.style.pointerEvents = 'none';

                        // if we are close to the right side of the window, move the tooltip to the left
                        if (position.left + window.pageXOffset + tooltipModel.caretX + tooltipEl.offsetWidth > window.innerWidth) {
                            tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX - tooltipEl.offsetWidth + 'px';
                        }
                    }
                },
                verticalHoverLine,
            }
        },
        plugins: [verticalHoverLine]
    });
}
